const rulesManager = {
  init(config, lib, betData) {
    this.popup = document.querySelector('#rules');
    this.content = document.querySelector('#rules-content');
    this.closeBtn = document.querySelector('#rules-close');

    this.lib = lib;

    this.setBet(betData);
    this.genRules(config);
    this.genSymbolsHtml(config);
    this.genScatterText(config);
    this.genWildText(config);

    this.eventDispatcher = this.eventDispatcher || new createjs.EventDispatcher();

    this.popup.addEventListener('scroll', () => this.fixMobileBarsToggle());
    this.closeBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('close'));
  },

  addEventListener(evt, fn) {
    this.eventDispatcher = this.eventDispatcher || new createjs.EventDispatcher();
    this.eventDispatcher.addEventListener(evt, fn);
  },

  setBet({ bet, lines }) {
    this.bet = bet;
    this.lines = lines;
  },

  genScatterText(config) {
    const multiText = config.freeSpinsMulti > 1 ? `<br>c умножением выигрыша на ${config.freeSpinsMulti}` : '';

    this.scatterText = `<div class="rules__text">3 и более запускают <br>
    ${config.freeSpinsAmount} бесплатных розыгрышей ${multiText}</div>`;
  },

  genWildText(config) {
    this.wildText = `<div class="rules__text">Заменяет любой символ <br>
      кроме ${this.symbols[config.scatter]} <br>
      Удваивает выигрыш по линии</div>`;
  },

  genRules(config) {
    const reduceRulesFunc = (acc, curr) => {
      const sameRule = acc.find(el => this.isSameRule(el, curr));
      if (sameRule) {
        sameRule.symbols.push(curr.symbols[0]);
        return acc;
      }
      return [...acc, curr];
    };

    const sortRulesFunc = (a, b) => {
      if (a.wild) return -1;
      else if (b.wild) return 1;
      else if (a.scatter) return -1;
      else if (b.scatter) return 1;

      return b.win[0] - a.win[0];
    };

    this.rules = this.mapWinTable(config)
      .reduce(reduceRulesFunc, [])
      .sort(sortRulesFunc);
  },

  mapWinTable({ winTable, scatter, wild }) {
    return winTable.map((item, i) => ({
      symbols: [i],
      win: item.filter(el => !!el).reverse(),
      scatter: i === scatter,
      wild: i === wild,
    }));
  },

  isSameRule(rule1, rule2) {
    return rule1.win.length === rule2.win.length &&
      rule1.win.every((el, i) => rule1.win[i] === rule2.win[i]) &&
      rule1.scatter === rule2.scatter &&
      rule1.wild === rule2.wild;
  },

  genSymbolsHtml({ winTable }) {
    const canvas = document.createElement('canvas');
    const stage = new createjs.Stage(canvas);

    this.symbols = winTable.map((win, i) => this.genSymbolHtml(i, stage));
  },

  genSymbolHtml(i, stage) {
    console.log('★ rulesManager.genSymbolHtml:', `Symbol${i}`);

    const symbol = new this.lib[`Symbol${i}`]();
    const scale = 0.65;

    /* eslint-disable no-param-reassign */
    stage.canvas.width = symbol.getBounds().width * scale;
    stage.canvas.height = symbol.getBounds().height * scale;
    /* eslint-enable no-param-reassign */

    symbol.set({ scaleX: scale, scaleY: scale });
    stage.removeAllChildren();
    stage.addChild(symbol);
    stage.update();

    return `<img src="${stage.toDataURL()}" alt="" class="rules__img">`;
  },

  genRuleHtml(rule) {
    const symbolsHtml = rule.symbols.map(i => this.symbols[i]).join('');
    const winHtml = rule.win.map((win, i) =>
      `<div>
        <span class="rules__win-amount">${5 - i}x</span>
        <span class="rules__win-value">${rule.scatter ? win * this.bet * this.lines : win * this.bet}</span>
      </div>`).join('');

    return `<div class="rules__item">
      <div class="rules__icons">${symbolsHtml}</div>
      <div class="rules__win">${winHtml}</div>
      ${rule.wild ? this.wildText : ''}
      ${rule.scatter ? this.scatterText : ''}
    </div>`;
  },

  genHtml() {
    return this.rules.map(rule => this.genRuleHtml(rule)).join('');
  },

  fixMobileBarsToggle() {
    const minScroll = Math.max(this.popup.scrollTop, 1);
    const scroll = Math.min(minScroll, this.popup.scrollHeight - this.popup.offsetHeight - 1);
    this.popup.scrollTop = scroll;
  },

  show() {
    this.content.innerHTML = this.genHtml();
    this.popup.hidden = false;
    this.fixMobileBarsToggle();
  },

  hide() {
    this.popup.hidden = true;
  },

  isVisible() {
    return !this.popup.hidden;
  },
};

export default rulesManager;



// WEBPACK FOOTER //
// ../base/js/managers/rules.js